module.exports = __webpack_public_path__ + "img/nzipo_logo.ddc2c20b.png";